
import $ from "jquery"

import {
  requestIdleCallback,
} from "plugins/request-animation-frame-polyfill"

import Index from "./index"

function initAllMatchingElements() {
  Index.init()
}

function onLoad() {
  requestIdleCallback(() => {
    initAllMatchingElements()

    // TODO: Move to page specific scripts later
    // For some reason only the jQuery instance on window works
    $(document).on("ajaxSuccess", () => {
      setTimeout(initAllMatchingElements, 1000)
    })
  })
}

export default onLoad
